// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3jHYt","inner":"Form_inner__r-8dv","range":"Form_range__2I2FF","name":"Form_name__z3hLu","actions":"Form_actions__3VcI4"};